import { type ReactElement } from 'react'
import { MOBILE_CONTROL_HEIGHT } from '@theme'
import { type MaterialSymbolType } from '@front/model'
import { TButton } from '../../buttons'

export const SidebarUserMenuItem = ({
  icon,
  label,
  onClick,
  tall = false,
}: {
  icon: MaterialSymbolType
  label: string
  onClick: VoidFunction
  tall?: boolean
}): ReactElement => {
  return (
    <TButton h={tall ? MOBILE_CONTROL_HEIGHT : undefined} icon={icon} justify='start' variant='ghost' onClick={onClick}>
      {label}
    </TButton>
  )
}
